<script setup lang="ts">
import TermsofUse from '../components/TermsofUse.vue';

definePageMeta({
  layout: 'onboarding',
  auth: false,
});
</script>


<template>
  <v-container class="d-flex justify-center pa-0 mt-5">
    <TermsofUse :show-header="true" :is-onboarding="false" />
  </v-container>
</template>
